export function canUserCreateWiki(isAdmin: boolean, isEditor: boolean, restrictWikis: boolean): boolean {
    return isAdmin || isEditor || !restrictWikis;
}

export function canUserEditAndDeleteWiki(isAdmin: boolean, isEditor: boolean, currentUserId: number, wikiEditorId: number): boolean {
    return isAdmin || isEditor || wikiEditorId === currentUserId;
}

export function canUserCreateArticle(isAdmin: boolean, isEditor: boolean, restrictWikis: boolean, allowEditing: boolean, allowNewArticles: boolean, currentUserId: number, wikiEditorId: number): boolean {
    return allowNewArticles && (isAdmin || isEditor || (!restrictWikis && allowEditing) || wikiEditorId === currentUserId);
}

export function canUserEditAndDeleteArticle(isAdmin: boolean, isEditor: boolean, restrictWikis: boolean, allowEditing: boolean, currentUserId: number, wikiEditorId: number, articleEditorId: number): boolean {
    return isAdmin || isEditor || (!restrictWikis && allowEditing) || wikiEditorId === currentUserId || articleEditorId === currentUserId;
}

export function canUserCreateSection(isAdmin: boolean, isEditor: boolean, restrictWikis: boolean, allowEditing: boolean, currentUserId: number, wikiEditorId: number, articleEditorId: number): boolean {
    return isAdmin || isEditor || (!restrictWikis && allowEditing) || wikiEditorId === currentUserId || articleEditorId === currentUserId;
}

export function canUserEditAndDeleteSection(isAdmin: boolean, isEditor: boolean, restrictWikis: boolean, allowEditing: boolean, currentUserId: number, wikiEditorId: number, articleEditorId: number, sectionEditorId: number): boolean {
    return isAdmin || isEditor || (!restrictWikis && allowEditing) || wikiEditorId === currentUserId || articleEditorId === currentUserId || sectionEditorId === currentUserId;
}
